import { connect } from 'react-redux'
import ManageCheckItemComponent from '../components/ManageCheckItemComponent.jsx';
import {
  forwardToSelectCategory,
  forwardToSetCheckItemAvailable,
  forwardToDeleteCheckItem,
  forwardToSetAppendCheckItemModalVisibility,
  forwardToSetHideCheckItemModal,
  forwardToSetCheckItemDescription,
  forwardToSetCheckItemPrice,
  forwardToSetCheckItemNote,
  forwardToAppendCheckItem,
  forwardToFindCategories,
} from '../actions';

const mapStateToProps = (state) => ({
  view: state.getIn(['checkCardReducer', 'view']),
  request: state.getIn(['checkCardReducer', 'request']),

  alert: state.getIn(['manageCheckItemReducer', 'alert']),

  modal: state.getIn(['manageCheckItemReducer', 'modal']),

  modalRequest: state.getIn(['manageCheckItemReducer', 'modal']).get('request'),
})

const mapDispatchToProps = (dispatch) => ({

  changeCategory: (index) =>
    dispatch(forwardToSelectCategory(index)),

  showOrHideCheckItem: (checkItem) =>
    dispatch(forwardToSetCheckItemAvailable(checkItem)),

  deleteItem: (ckItemId) =>
    dispatch(forwardToDeleteCheckItem(ckItemId)),

  showModal: (category, ckSet) =>
    dispatch(forwardToSetAppendCheckItemModalVisibility(category, ckSet, true)),

  hideModal: () =>
    dispatch(forwardToSetHideCheckItemModal()),

  setDescription: (value) =>
    dispatch(forwardToSetCheckItemDescription(value)),

  setPrice: (value) =>
    dispatch(forwardToSetCheckItemPrice(value)),

  setNote: (value) =>
    dispatch(forwardToSetCheckItemNote(value)),


  appendCheckItem: (checkSet, desc, price, note) => {
    // console.log('checkSet' + checkSet.id);
    // console.log('desc:' + desc);
    // console.log('price: ' + price);
    // console.log('note:' + note);

    dispatch(forwardToAppendCheckItem(checkSet, desc, price, note))
  },

  findCheckCategories: () => {
    dispatch(forwardToFindCategories());
  },

})

const ManageCheckItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCheckItemComponent)

export default ManageCheckItemContainer;


// WEBPACK FOOTER //
// ./src/containers/ManageCheckItemContainer.jsx